var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-list',{staticClass:"mb-n2",attrs:{"items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }